import firebase from 'firebase/app'

const firebaseConfig = {
    apiKey: "AIzaSyAQl5KwrYxPgeLQjZla1umGTMJjIFSRxrc",
    authDomain: "notarios-cuu.firebaseapp.com",
    databaseURL: "https://notarios-cuu.firebaseio.com",
    projectId: "notarios-cuu",
    storageBucket: "notarios-cuu.appspot.com",
    messagingSenderId: "159170979516",
    appId: "1:159170979516:web:4d9b793fb9a448d11ed2b9"
  };


// Initialize Firebase
firebase.initializeApp(firebaseConfig);